// Copyright (c) 2020 Deere & Company

import RgaMassUpdate from '../../rga/mass-update/state-connector';

export default {
    component: RgaMassUpdate,
    name: 'Mass Update RGA',
    path: '/rga/mass-update'
};




// WEBPACK FOOTER //
// ./src/routes/rga/rga-mass-update.js